import { SchoolEntityI } from "@seneca/schools-service-types";

import { queryClient } from "services";

import { schoolsKey } from "../../consts";

export const getSchools = () => {
  return queryClient.getQueryData<SchoolEntityI[]>([schoolsKey]) || [];
};
